import {IMapFieldsState, IMapFieldsAction, MapFieldsActionEnum} from './types'
import {recursiveEditorM} from "@utils/recursive";

const initialState: any = {
  typeStoreFields: "FIELDS",
  
  fields: {},
 
  
  optionsFields: {
    zIndex: 10,
    filters: {
      typeFields: []
    }
  },
  
  selectedField: {},
  
  errorFields: '',
  isLoadingFields: false,
  isFetchDataFields: false,
  isFetchDynamicFields: false,
  
}


const fieldsReducer = (baseState = initialState, baseAction: any): any => {
  const state = Object.assign({}, baseState)
  const action = Object.assign({}, baseAction)
  
  switch (action.type) {
    
    case MapFieldsActionEnum.FETCH_DATA_FIELDS :
      return {
        ...state,
        fields: action.payload.fields,
        isFetchDataFields: true
      }
    
    case MapFieldsActionEnum.FETCH_DYNAMIC_DATA_FIELD :
      
      let fields = recursiveEditorM(
        state.fields,
        action.payload.fields,
        state.typeStoreFields
      )
      
      return {
        ...state,
        fields,
        isFetchDynamicFields: true
      }
    case MapFieldsActionEnum.SELECT_FIELD :
      let findField = {}
      // action.payload.id
      //место поиска по дереву элементов
      
      return {
        ...state,
        selectedField: findField
      }
  
    case MapFieldsActionEnum.FETCH_FIELDS_TYPE :
      
      return {
        ...state,
        optionsFields: {
          ...state.optionsFields,
          filters: {
            typeFields: action.payload
          }
        }
      }
    
    //========================================================>
    case MapFieldsActionEnum.IS_LOADING_FIELDS :
      return {
        ...state,
        isLoadingFields: action.payload
      }
    case MapFieldsActionEnum.GET_ERROR_FIELDS :
      return {
        ...state,
        errorFields: action.payload
      }
    
    default :
      return state
  }
}

export default fieldsReducer;